import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import AiSparkleNew from './icon-ai-sparkle-new.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <AiSparkleNew {...validProps} />;
}
SvgComponent.iconName = 'aiSparkleNew';

export const AiSparkleNewIcon = svgIconWrapper(SvgComponent);
